module.exports = __webpack_public_path__ + "static/media/other.346ff32e.svg";